/**
 * 全局存储用户假消息
 */
var utils = require('./utils');

var queque = utils.queque;

var isEmpty = utils.isEmpty;

var sumBigNumber = utils.sumBigNumber;

var strToNumCompare = utils.strToNumCompare;

var config = require('./config');

var falseMsgs = queque(10);

var false_msgs_queue;

var existFalseMsgs = {};

var falseLastMsgs = {};

var push_records = {};

var falseUnreadNumbers = {};

var falseReadsRecords = {};

var falseUnreadTotal = 0;

var userKey = '';

var isInited = false;

var saveExistFalseMsgs = (msg, tmpKey) => {
  if (!isEmpty(msg.msg_id) && !isEmpty(tmpKey)) {
    if (isEmpty(existFalseMsgs[tmpKey])) {
      existFalseMsgs[tmpKey] = {};
    }
    if (!isEmpty(existFalseMsgs[tmpKey][msg.msg_id])) {
      return
    }
    existFalseMsgs[tmpKey][msg.msg_id] = msg;
    if (!isEmpty(msg.follow_msg_id) && !isEmpty(existFalseMsgs[tmpKey][msg.follow_msg_id])) {
      let follow_msg = existFalseMsgs[tmpKey][msg.follow_msg_id];
      follow_msg.fellow_id = msg.msg_id;
    }
  }
};

var deleteExistFalseMsgs = (msgs) => {
  var deleted_msg_ids = {};
  var tmp_msg;
  var tmpKey;
  (msgs || []).forEach(function(msg){ 
    if (!isEmpty(msg.msg_id) && !isEmpty(msg.tmpKey)) {
      if (isEmpty(existFalseMsgs[msg.tmpKey])) {
        return
      }
      tmpKey = msg.tmpKey;
      if (!isEmpty(existFalseMsgs[tmpKey][msg.msg_id])) {
        tmp_msg = existFalseMsgs[tmpKey][msg.msg_id];
        delete existFalseMsgs[tmpKey][tmp_msg.msg_id];
        delete push_records[msg.msg_id];
        deleted_msg_ids[tmp_msg.msg_id] = true;
      }
    }
  });
  if (isEmpty(tmp_msg)) return;
  var _msgs = falseMsgs.pull();
  var deleted_msg_index = [];
  _msgs.forEach(function(_msg, _index){
    if (_msg && _msg.msg_id && deleted_msg_ids[_msg.msg_id]) {
      deleted_msg_index.push(_index);
    }
  });
  deleted_msg_index.sort();
  var falseMsgslen = falseMsgs.len();
  deleted_msg_index.forEach(function(index){
    var _falseMsgslen = falseMsgs.len();
    falseMsgs.remove(index - (falseMsgslen - _falseMsgslen), function(){

    });
  });
  if (deleted_msg_index.length) {
    var _falseMsgs = falseMsgs.pull();
    for(var index=0; index < _falseMsgs.length; index++) {
      var falseNew = _falseMsgs[index];
      if (isEmpty(falseLastMsgs[falseNew.belong_to])) {
        falseLastMsgs[falseNew.belong_to] = {};
      }
      falseLastMsgs[falseNew.belong_to][falseNew.tmpKey] = falseNew;
    }
    if (!_falseMsgs.length) {
      falseLastMsgs = {};
    }
    try {
      window.localStorage.setItem('false_msgs_queue', JSON.stringify({
          msgs: falseMsgs.pull()
      }));
    }catch(e){

    }
  }
};

function falseMsgCut(deleted, lasted) {
  if (deleted && lasted && deleted.length && lasted.length) {
    var firstMsg = lasted[0];
    var changed = false;
    var originalMsgId = null;
    if (firstMsg.follow_msg_id) {
      originalMsgId = firstMsg.msg_id;
      for(var index=deleted.length-1;index>=0;index--) {
        if (deleted[index].belong_to !== firstMsg.belong_to) {
          continue;
        }
        if (deleted[index].tmpKey !== firstMsg.tmpKey) {
          continue;
        }
        if (deleted[index].msg_id === firstMsg.follow_msg_id) {
          firstMsg.follow_msg_id = deleted[index].follow_msg_id;
          firstMsg.msg_id = deleted[index].msg_id;
          changed = true;
        }
      }
      if (changed && originalMsgId) {
        for(var index=1;index<lasted.length;index++) {
          if (lasted[0].belong_to === lasted[index].belong_to && lasted[0].tmpKey === lasted[index].tmpKey && lasted[index].follow_msg_id === originalMsgId) {
            lasted[index].follow_msg_id = lasted[0].msg_id;
            break;
          }
        }
      }
    }
  }
};

function dicInit() {
  try {
    false_msgs_queue = window.localStorage.getItem('false_msgs_queue') || '{}';
    false_msgs_queue = JSON.parse(false_msgs_queue);
    false_msgs_queue = false_msgs_queue.msgs || [];
  }catch(e){
    false_msgs_queue = [];
  }

  falseMsgs.push(false_msgs_queue, falseMsgCut);

  var _falseMsgs = falseMsgs.pull();

  for(var index=0; index < _falseMsgs.length; index++) {
    var falseNew = _falseMsgs[index];
    if (falseNew.tmpKey) {
      saveExistFalseMsgs(falseNew, falseNew.tmpKey);
      if (isEmpty(falseLastMsgs[falseNew.belong_to])) {
        falseLastMsgs[falseNew.belong_to] = {};
      }
      falseLastMsgs[falseNew.belong_to][falseNew.tmpKey] = falseNew;
    }
  }
}

var gatherExistFalseMsgs = (tmpKey, msg_id) => {
  var false_news = [];
  if (!isEmpty(msg_id) && !isEmpty(tmpKey)) {
    msg_id = sumBigNumber(msg_id, '1');
    if (!isEmpty(existFalseMsgs[tmpKey])) {
      while (!isEmpty(existFalseMsgs[tmpKey][msg_id]) && existFalseMsgs[tmpKey][msg_id].belong_to === userKey) {
        if (existFalseMsgs[tmpKey][msg_id]) {
          false_news.push(existFalseMsgs[tmpKey][msg_id]);
        }
        if (!isEmpty(existFalseMsgs[tmpKey][msg_id].fellow_id)) {
          var fellow_id = existFalseMsgs[tmpKey][msg_id].fellow_id;
          if (fellow_id == msg_id) {
            break;
          } else {
            msg_id = fellow_id;
          }
        } else {
          break;
        }
      }
    }
  }
  return false_news;
}

function falseMsgMinus(tmpKey) {
  var read_key = userKey + '-' + tmpKey;
  falseReadsRecords[read_key] = falseLastMsgs[userKey] ? (falseLastMsgs[userKey][tmpKey] ? falseLastMsgs[userKey][tmpKey].msg_id : null) : null;
  var originalNumber = falseUnreadNumbers[tmpKey] || 0;
  falseUnreadNumbers[tmpKey] = 0;
  falseUnreadTotal -= originalNumber || 0;
}

function falseMsgPlus(tmpKey ,msgId) {
  var read_key = userKey + '-' + tmpKey;
  var plus = false;
  if (falseReadsRecords[read_key] && strToNumCompare(msgId, falseReadsRecords[read_key]) > 0) {
    plus = true;
  } else if (!falseReadsRecords[read_key]) {
    plus = true;
  }
  if (plus) {
    falseUnreadNumbers[tmpKey] = falseUnreadNumbers[tmpKey] || 0;
    falseUnreadNumbers[tmpKey] += 1;
    falseUnreadTotal += 1;
  }
}

function init() {
  if (!(window.wbWebRTCSDK && window.wbWebRTCSDK.isSupport)) {
    return;
  }
  if (!config['is_show_audio_video']) {
    return;
  }
  if (isInited) return;
  dicInit();
  isInited = true;
}

module.exports = {
  get: function () {
    !isInited && init();
    return falseMsgs.pull();
  },
  set: function (msgs) {
    !isInited && init();
    if (msgs instanceof Array && msgs.length) {
      msgs = msgs.filter(function (msg, index) {
        if (push_records[msg.msg_id]) {
          return false;
        } else {
          push_records[msg.msg_id] = true;
          return true;
        }
      })
      falseMsgs.push(msgs, falseMsgCut);
    } else {
      return
    }
    try {
        window.localStorage.setItem('false_msgs_queue', JSON.stringify({
            msgs: falseMsgs.pull()
        }));
    }catch(e){

    }
  },
  falseMsgMinus: falseMsgMinus,
  falseMsgPlus: falseMsgPlus,
  getReadMsgNumber: function (tmpKey) {
    return falseUnreadNumbers[tmpKey] || 0;
  },
  getFalseUnreadTotal: function () {
    return falseUnreadTotal;
  },
  setUser: function (user_id, user_source) {
    userKey = user_id + '@' + user_source;
  },
  getExistFalseMsg: function (tmpKey, msgId) {
    !isInited && init();
    if (existFalseMsgs[tmpKey] && !isEmpty(msgId) && typeof msgId === 'string' && userKey) {
      var _msgId = sumBigNumber(msgId, '1');
      var msg = existFalseMsgs[tmpKey][_msgId];
      if (msg && msg.belong_to === userKey) {
        return msg
      }
    }
    return null;
  },
  gatherFalseLastMsgs: function (userKey) {
    !isInited && init();
    return falseLastMsgs[userKey] ? falseLastMsgs[userKey] : {}
  },
  saveExistFalseMsgs: function () {
    !isInited && init();
    return saveExistFalseMsgs.apply(this, arguments);
  },
  gatherExistFalseMsgs: function () {
    !isInited && init();
    return gatherExistFalseMsgs.apply(this, arguments);
  },
  deleteExistFalseMsgs: function () {
    !isInited && init();
    return deleteExistFalseMsgs.apply(this, arguments);
  }
};